// extracted by mini-css-extract-plugin
export var modal = "_vg-0";
export var table = "_vg-1";